type IDBKey =
  | string
  | number
  | Date
  | ArrayBufferView
  | ArrayBuffer
  | IDBArrayKey;

export class LocalDbCrud<T> {
  db: IDBDatabase;
  store: string;

  constructor(db: IDBDatabase, store: string) {
    this.db = db;
    this.store = store;
  }

  getAllKeys(
    query: IDBKey | IDBKeyRange | null | undefined = undefined,
    index_name: string | undefined = undefined
  ): Promise<IDBValidKey[]> {
    const store = this.store;
    const transaction = this.db.transaction(this.store);
    const objectStore = transaction.objectStore(this.store);
    const request: IDBRequest<IDBValidKey[]> = index_name
      ? objectStore.index(index_name).getAllKeys(query)
      : objectStore.getAll(query);

    return new Promise<IDBValidKey[]>((resolve, reject) => {
      request.onerror = function (ev) {
        const error = `ERROR CRUD [${store}] getAllKeys() error`;
        console.log(error, ev);
        reject(new Error(error));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  getAll(
    query: IDBKey | IDBKeyRange | null | undefined = undefined,
    index_name: string | undefined = undefined
  ): Promise<T[]> {
    const store = this.store;
    const transaction = this.db.transaction(this.store);
    const objectStore = transaction.objectStore(this.store);
    const request: IDBRequest<T[]> = index_name
      ? objectStore.index(index_name).getAll(query)
      : objectStore.getAll(query);

    return new Promise<T[]>((resolve, reject) => {
      request.onerror = function (ev) {
        const error = `ERROR CRUD [${store}] getAll() error`;
        console.log(error, ev);
        reject(new Error(error));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  getByKey(key: IDBKey | IDBKeyRange): Promise<T> {
    const store = this.store;
    const transaction = this.db.transaction(this.store);
    const objectStore = transaction.objectStore(this.store);
    const request = objectStore.get(key);

    return new Promise(function (resolve, reject) {
      request.onerror = function (ev) {
        const error = `ERROR CRUD [${store}] getByKey() error`;
        console.log(error, ev);
        reject(new Error(error));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  put(key: IDBKey | undefined, value: T): Promise<IDBValidKey> {
    const store = this.store;
    const transaction = this.db.transaction(this.store, "readwrite");
    const objectStore = transaction.objectStore(this.store);
    const request = objectStore.put(
      // костыль, так как нельзя сохранять объекты, которые внутри имеют ссылки
      JSON.parse(JSON.stringify(value)),
      key
    );

    return new Promise<IDBValidKey>(function (resolve, reject) {
      request.onerror = function (ev) {
        const error = `ERROR CRUD [${store}] put() error`;
        console.log(error, ev);
        reject(new Error(error));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  delete(key: IDBKey | IDBKeyRange): Promise<IDBKey | IDBKeyRange> {
    const store = this.store;
    const transaction = this.db.transaction(this.store, "readwrite");
    const objectStore = transaction.objectStore(this.store);
    const request = objectStore.delete(key);

    return new Promise<IDBKey | IDBKeyRange>(function (resolve, reject) {
      request.onerror = function (ev) {
        const error = `ERROR CRUD [${store}] delete() error`;
        console.log(error, ev);
        reject(new Error(error));
      };
      request.onsuccess = function () {
        resolve(key);
      };
    });
  }
}
